<div class="container">

  <app-header-dialog [iconName]="'mail_outline'">
    {{ local_title }}
  </app-header-dialog>

  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>edit_note</mat-icon>
        Texto
      </ng-template>

      <div class='tab-content'>
        <mat-card appearance="outline">
          <mat-label>Templates</mat-label>
          <mat-select (ngModelChange)='selectedTemplateChange($event)' [ngModel]='selectedTemplate'>
            <mat-option *ngFor="let temp of templates" [value]="temp.id">
              {{ temp.name }}
            </mat-option>
          </mat-select>
        </mat-card>

        <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">
          <mat-form-field class="title-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="type-width" appearance="outline">
            <mat-label>Tipo</mat-label>
            <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.type">
              <mat-option *ngFor="let type of types" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="entityForm.controls.type.hasError('required')">
              O Típo é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="title-width" appearance="outline">
            <mat-label>Titulo do Email</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.subject"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.subject.hasError('required')">
              O Título é obrigatório
            </mat-error>
          </mat-form-field>


          <span class='template-width'>
            <mat-checkbox color='primary' [formControl]="entityForm.controls.isTemplate">
              Template
            </mat-checkbox>
          </span>

          <!--
          <ckeditor [editor]="Editor" [config]="{ 
                toolbar: [ 'heading', '|', 'undo', 'redo', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link', '|' ]
               }" [formControl]="entityForm.controls.text"></ckeditor>
-->

          <ckeditor [config]="{ 
                        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="entityForm.controls.text" [editor]="Editor"></ckeditor>

          <mat-error *ngIf="entityForm.controls.text.hasError('required')">
            O Texto é obrigatório
          </mat-error>
        </form>


      </div>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <div [ngClass]="{hidden: !spinner}">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
        <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab *ngIf="isEdit">
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>image_search</mat-icon>
        Imagens
      </ng-template>

      <div class='tab-content'>

        <div style="height:500px; overflow:auto;">

          <div style='width: 100%; height: 280px; margin-bottom:10px; text-align: center;'>

            <img style='display: block; width: 90%; border: solid 1px silver; margin: auto;'
              [src]='_letterSpeakersService.storedImageTop' *ngIf='_letterSpeakersService.storedImageTop'>

            <input #fileTop type="file" accept='image/png, image/jpg' style='display:none;'
              (change)="_letterSpeakersService.previewImageTop($event)" />

            <button mat-raised-button (click)='fileTop.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
              <span>[imagem_1] (800 x 200)</span>
            </button>

          </div>

          <div style='width: 100%; height: 230px; text-align: center;'>

            <img style='display: block; width: 90%; border: solid 1px silver; margin: auto;'
              [src]='_letterSpeakersService.storedImageBottom' *ngIf='_letterSpeakersService.storedImageBottom'>

            <input #fileBottom type="file" accept='image/png, image/jpg' style='display:none;'
              (change)="_letterSpeakersService.previewImageBottom($event)" />

            <button mat-raised-button (click)='fileBottom.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
              <span>[imagem_2] (800 x 40)</span>
            </button>

          </div>

          <div style='width: 100%; height: 630px; margin-bottom:10px; text-align: center;'>

            <img style='display: block; width: 90%; border: solid 1px silver; margin: auto;'
              [src]='_letterSpeakersService.storedImageBody' *ngIf='_letterSpeakersService.storedImageBody'>

            <input #fileBody type="file" accept='image/png, image/jpg' style='display:none;'
              (change)="_letterSpeakersService.previewImageBody($event)" />

            <button mat-raised-button (click)='fileBody.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
              <span>[imagem_corpo]</span>
            </button>

          </div>

        </div>

      </div>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <div [ngClass]="{hidden: !spinner}">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
        <button mat-raised-button (click)='updateImages()' *ngIf="isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>
    </mat-tab>

  </mat-tab-group>

</div>